import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=1a015374&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=1a015374&prod&lang=less"
import style1 from "./Main.vue?vue&type=style&index=1&id=1a015374&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a015374",
  null
  
)

export default component.exports